import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const classesSlice = createSlice({
  name: "classesSlice",
  initialState: {
    classData: [],
    gradeData: [],
    facultyGradeData: {},
    terms: [],
    attendance: [],
    classRoster: [],
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },

  reducers: {
    setclassData: (state, action) => {
      state.classData = action.payload;
    },
    setgradesData: (state, action) => {
      state.gradeData = action.payload;
    },
    setFacultyGradeData: (state, action) => {
      state.facultyGradeData = action.payload;
    },
    setClassRosterData: (state, action) => {
      state.classRoster = action.payload;
    },
    setTermsData: (state, action) => {
      state.terms = action.payload;
    },
    setAttendanceData: (state, action) => {
      state.attendance = action.payload;
    },
    removeAttedanceData: (state, action) => {
      state.attendance = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.classData = action.payload;
    },
  },
});

export const {
  setclassData,
  setgradesData,
  setFacultyGradeData,
  setErrorMessage,
  setErrorStatusCode,
  setDataFetchingStatus,
  removeElementsFromArray,
  setTermsData,
  setAttendanceData,
  removeAttedanceData,
  setClassRosterData,
} = classesSlice.actions;

export const getClassData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`student/classes/${data}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setclassData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getGradeData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`student/grades/${data}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setgradesData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getFacultyClassData = (data) => (dispatch) => {

  console.log(data,"datatatat")
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`class/facultyclasses/${data}`)
    .then((response) => {
      console.log(response.data,"Responseee")
      dispatch(setDataFetchingStatus(false));
      dispatch(setclassData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      // dispatch(setErrorMessage(error.response.data.error));
      // dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getFacultyGradesData = (classId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`faculty/grades/${classId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setFacultyGradeData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response?.data?.error || error.message));
      dispatch(setErrorStatusCode(error.response?.status));
    });
};

export const saveFacultyGradesData = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`faculty/classgrades/save`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response?.data?.error || error.message));
      dispatch(setErrorStatusCode(error.response?.status));
    });
};

export const getAttendanceData = ({classId, studentId}) => (dispatch) => {
  dispatch(removeAttedanceData([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/class/attendance/${classId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAttendanceData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getClassRosterData = (classId) => (dispatch) => {
  console.log("classId:", classId);
  dispatch(removeAttedanceData([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/faculty/classroster/${classId.classId}`)
    .then((response) => {
      console.log("Slice response", response)
      dispatch(setDataFetchingStatus(false));
      dispatch(setClassRosterData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.message));
      // dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateParmsForClass = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`class/update`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getTermData = () => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`class/classes/getTerms`)
    .then((response) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setTermsData(response.data));
    })
    .catch((error) => {
      // dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const clearClassData = () => (dispatch) => {
  dispatch(removeElementsFromArray([]));
};

export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export default classesSlice.reducer;
